<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Modification d'une <strong>commission spéciale</strong>  
          </div> 
          <b-row class="form-group">         
            <b-col md="6">
              <label for="entite_id">Entité</label>
              <b-form-select id="entite_id" :plain="true" :options="options" v-model="commission.entite_id">
              </b-form-select>
              <!-- <b-form-input type="text" v-model="commission.libelle" placeholder="Libéllé de la commission"></b-form-input> -->
            </b-col>
            <b-col md="6">
              <label for="solde">Valeur (%)</label>
              <b-form-input type="number" min="0" max="50"  v-model="commission.valeur" placeholder="Valeur de la commission"></b-form-input>
            </b-col>
          </b-row>    
          <b-row class="form-group">         
            <b-col md="6">
              <label for="typeoperation_code">Code Opération</label>
              <b-form-select id="typeoperation_code" :plain="true" :options="options_code_operation" v-model="commission.typeoperation_code">
              </b-form-select>
              <!-- <b-form-input type="text" v-model="commission.libelle" placeholder="Libéllé de la commission"></b-form-input> -->
            </b-col>
            <b-col md="3">
              <label for="solde">Date du</label>
              <b-form-input type="date" v-model="commission.date_du" placeholder=""></b-form-input>
            </b-col>
            <b-col md="3">
              <label for="solde">Date au</label>
              <b-form-input type="date" v-model="commission.date_au" placeholder=""></b-form-input>
            </b-col>
          </b-row>    
          <b-row class="form-group">         
            
          </b-row>    
          <div slot="footer">
            <span v-if="can('taxe-edit')"><b-button type="submit" size="sm" variant="primary" @click.prevent="put()"><i class="fa fa-dot-circle-o"></i> Modifier</b-button></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>     
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      
      showDismissibleAlert: false,
      response:{},
      options : [],
      options_code_operation : [{value:'PME',text:'PME'},{value:'PMR',text:'PMR'},{value:'TAR',text:'TAR'},{value:'TAE',text:'TAE'}],
      commission:{
            entite_id: '',
            typeoperation_code: '',
            valeur: '',
            date_du: '',
            date_au: '',
            _method:'PUT'
      },
      typeoperation:[]
    }
  },
   methods:{
      goBack() {
        this.$router.go(-1)
      },
      countDownChanged (dismissCountDown) {
          this.dismissCountDown = dismissCountDown
      },
      showAlert () {
        this.dismissCountDown = this.dismissSecs
      },
      async get_all_entities(){
          let serverParams= {
                page:1,
                current_page: 1,
                paginate: 10
              }
          await this.$store.dispatch('entity/get_all_entities',serverParams).then(()=>{
            return this.entities = store.getters['entity/rows'];    
          })
          this.entities.forEach((element)=>{
              this.options.push({
                value:element.id,
                text:element.nom_commercial.toUpperCase(),
              })
          })
    },
      goBack() {
        this.$router.go(-1)
      },
      can(perm){
        return store.getters['auth/can'](perm)
      },
      async put(){     
          this.response = await this.$store.dispatch('commission/put_commissions',{id:this.$route.params.id,commission:this.commission})
          this.showAlert()
          //this.reset()
      },
      async displayCommissions() {
        let response = await this.$store.dispatch('commission/show_commissions',this.$route.params.id)    
        this.commission.entite_id= response.entite_id,
        this.commission.typeoperation_code= response.typeoperation_code,
        this.commission.valeur= response.valeur,
        this.commission.date_du= response.date_du,
        this.commission.date_au= response.date_au
      }
  },
  mounted(){
    this.get_all_entities()
    this.displayCommissions()
  }
}
</script>
